import { questionOpenStateId } from '../constants/common';

export const isCloseQuestionRejected = (question) =>
  question?.stateId === questionOpenStateId && question?.comment;
